/* eslint-disable @stylistic/max-len */

'use server';

import { parse } from 'valibot';

import { ACTION_STATUS_ERROR, ACTION_STATUS_SUCCESS } from '@/actions';
import {
  postEnquiryFormStep1 as postEnquiryFormStep1Api,
  postEnquiryFormStep2 as postEnquiryFormStep2Api,
  requestEmailEnquiryDataSchema,
  requestStep1DataSchema as enquiryFormStep1RequestDataSchema,
  requestStep2DataSchema as enquiryFormStep2RequestDataSchema,
} from '@/apis/server/new-car/v1/enquiry-form/post';
import {
  postEmailEnquiryForm,
} from '@/apis/server/new-car/v1/enquiry-form/post/api';

import type { Action, ActionEnquiry } from './types';

export const postEnquiryFormStep1: Action = async (formData) => {
  try {
    if (!formData) {
      throw new Error('Empty form data');
    }

    const parsedData = parse(enquiryFormStep1RequestDataSchema, {
      memberId: formData.get('memberId') ? Number(formData.get('memberId')) : null,
      email: formData.get('email') || '',
      countryCode: formData.get('countryCode') || '',
      name: formData.get('name') || '',
      contact: formData.get('contact') ? Number(formData.get('contact')) : 0,
      carId: formData.get('carId') ? Number(formData.get('carId')) : 0,
      recaptchaToken: formData.get('recaptchaToken') || '',
    });

    const response = await postEnquiryFormStep1Api({
      data: parsedData,
    });

    return {
      status: ACTION_STATUS_SUCCESS,
      data: response,
    };
  } catch (error) {
    return {
      status: ACTION_STATUS_ERROR,
      error: 'Failed to post enquiry form',
    };
  }
};

export const postEnquiryFormStep2: Action = async (formData) => {
  try {
    if (!formData) {
      throw new Error('Empty form data');
    }

    const parsedData = parse(enquiryFormStep2RequestDataSchema, {
      msg: formData.get('msg') ?? '',
      enquiryId: Number(formData.get('enquiryId') ?? '0'),
      dealerCount: JSON.parse(String(formData.get('dealerCount'))),
      submodelId: JSON.parse(String(formData.get('submodelId'))),
      isFromMobile: Boolean(String(formData.get('isFromMobile') ?? 'false')),
    });

    const response = await postEnquiryFormStep2Api({
      data: parsedData,
    });

    return {
      status: ACTION_STATUS_SUCCESS,
      data: response,
    };
  } catch (error) {
    return {
      status: ACTION_STATUS_ERROR,
      error: 'Failed to post enquiry form',
    };
  }
};

export const emailEnquiryForm: ActionEnquiry = async (formData) => {
  try {
    if (!formData) {
      throw new Error('Empty form data');
    }

    const memberId = formData.get('memberId') ? Number(formData.get('memberId')) : null;
    const name = formData.get('name');
    const contact = formData.get('contact');
    const dealerID = formData.get('dealerID');
    const isFromMobile = !!formData.get('isFromMobile');
    const model = formData.get('model');
    const message = formData.get('message');
    const recaptchaToken = formData.get('recaptchaToken');
    const email = formData.get('email');
    const countryCode = formData.get('countryCode');

    const response = await postEmailEnquiryForm({
      data: parse(requestEmailEnquiryDataSchema, {
        memberId,
        name,
        contact,
        model,
        dealerID,
        message,
        isFromMobile,
        recaptchaToken,
        email,
        countryCode,
      }),
    });

    return {
      status: ACTION_STATUS_SUCCESS,
      data: response,
    };
  } catch (error) {
    return {
      status: ACTION_STATUS_ERROR,
      error: 'Failed to post enquiry form',
    };
  }
};
